import { useNavigate } from 'react-router-dom';
import { Button } from "@/Components/ui/button";
import { Send, QrCode } from "lucide-react";

const ActionButtons = () => {
    const navigate = useNavigate();

    return (
        <div className="space-y-4 mb-8 mt-[50px]">
            <center> 
                <Button
                    className={`w-full bg-ps-blue-dark hover:bg-blue-600 text-white w-80 align-center h-[50px] mb-10`} onClick={() => navigate('/feedback')}
            >
                <Send className="mr-2" size={20} />
                Verstuur je feedback
            </Button>
                <br></br> 
            <Button
                    className={`w-full bg-ps-orange  hover:opacity-75 text-white w-80 align-center h-[50px] mb-10`} onClick={() => navigate('/qr-code')}
            >
                <QrCode className="mr-2" size={20} />
                Genereer QR code
                </Button></center>
            </div>
    );
};

export default ActionButtons;